import styled from 'styled-components';

export const LineItemDescription = styled.div`
  width: 100%;
  font-size: 1.2rem;
  font-family: ${Styles.fontFamily.base};
  line-height: 1;
`;
